// +----------------------------------------------------------------------
// | API接口地址
// +----------------------------------------------------------------------
// | Copyright (c) 2018 安徽秒速科技有限公司 All rights reserved.
// +----------------------------------------------------------------------
// | Author：tangfei <957987132@qq.com>
// +----------------------------------------------------------------------

//引入配置文件
import appConfig from "@/config/app";

//接口地址
let hostName = appConfig.devMode ? appConfig.ajaxApi.devHostName : appConfig.ajaxApi.hostName;
let version = appConfig.devMode ? '' : appConfig.ajaxApi.version;
let url = hostName + "/" + version;

//接口方法
const api = {
    // +--------------------------------
    // | http接口
    // +--------------------------------

    //账号密码登录
    doLoginPwd: {
        'url': url + 'no/doLoginPwd',
        'description': '账号密码登录'
    },

    //获取注册验证码
    sendRegisterCode: {
        'url': url + 'no/sendRegisterCode',
        'description': '获取注册验证码'
    },

    //注册
    doRegister: {
        'url': url + "no/doRegister",
        'description': '注册'
    },

    //token换取tokey
    tokey: {
        'url': url + "auth/tokey",
        'description': 'token换取tokey'
    },

    //修改昵称/时区/头像
    updateUserInfo: {
        'url': url + "auth/updateUserInfo",
        'description': '修改昵称/时区/头像'
    },

    //上传头像
    upImg: {
        'url': url + "auth/upImg",
        'description': '上传头像'
    },

    //关于我们
    aboutUs: {
        'url': url + "no/aboutUs",
        'description': '关于我们'
    },

    //token获取客户信息
    getUserInfo: {
        'url': url + "auth/token",
        'description': 'token获取客户信息'
    },

    //发送修改密码验证码接口
    sendUpdatePwdCode: {
        'url': url + "no/sendUpdatePwdCode",
        'description': 'token获取客户信息'
    },

    //修改密码
    updatePwd: {
        'url': url + "auth/updatePwd",
        'description': '修改密码'
    },

    //发送忘记密码验证码接口
    sendForgetPwdCode: {
        'url': url + "no/sendForgetPwdCode",
        'description': '发送忘记密码验证码接口'
    },

    //忘记密码
    updateForgetPwd: {
        'url': url + "no/updateForgetPwd",
        'description': '忘记密码'
    },

    //退出
    doLoginOut: {
        'url': url + "auth/doLoginOut",
        'description': '退出'
    },

    //获取设备分类
    catList: {
        'url': url + "auth/catList",
        'description': '获取设备分类'
    },

    //用户设备分类保存
    customerCatSave: {
        'url': url + "auth/customerCatSave",
        'description': '用户设备分类保存'
    },

    //用户设备分类删除
    customerCatDel: {
        'url': url + "auth/customerCatDel",
        'description': '用户设备分类删除'
    },

    //用户设备保存
    custDeviceSave: {
        'url': url + "auth/custDeviceSave",
        'description': '用户设备保存'
    },

    //用户设备删除
    customerDeviceDel: {
        'url': url + "auth/customerDeviceDel",
        'description': '用户设备删除'
    },

    //token换取视频accessToken
    videoAccessToken: {
        'url': url + "auth/videoAccessToken",
        'description': 'token换取视频accessToken'
    },

    //我的消息列表
    myMessages: {
        'url': url + "auth/myMessages",
        'description': '我的消息列表'
    },

    //报修消息保存
    customerRepairSave: {
        'url': url + 'auth/customerRepairSave',
        'description': '报修消息保存'
    },

    //报修消息列表
    customerRepairs: {
        'url': url + 'auth/customerRepairs',
        'description': '报修消息列表'
    },

    //报修消息详情
    customerRepair: {
        'url': url + 'auth/customerRepair',
        'description': '报修消息详情'
    },

    //常见问题列表
    questions: {
        'url': url + 'auth/questions',
        'description': '常见问题列表'
    },

    //常见问题详情
    question: {
        'url': url + 'auth/question',
        'description': '常见问题详情'
    },

    //意见反馈保存
    customerFeedbackSave: {
        'url': url + 'auth/customerFeedbackSave',
        'description': '意见反馈保存'
    },

    //获取场景分类
    listSceneCat: {
        'url': url + 'auth/listSceneCat',
        'description': '获取场景分类'
    },

    //用户场景分类保存
    custSceneCatSave: {
        'url': url + 'auth/custSceneCatSave',
        'description': '用户场景分类保存'
    },
    //场景分类删除
    delSceneCat: {
        'url': url + 'auth/delSceneCat',
        'description': '场景分类删除'
    },
    //获取场景分类下的场景
    sceneCatListByCatId: {
        'url': url + 'auth/sceneCatListByCatId',
        'description': '获取场景分类下的场景'
    },

    //用户定时场景保存/修改
    customerTiming: {
        'url': url + 'auth/customerTiming',
        'description': '用户定时场景保存/修改'
    },

    //用户情景场景保存/修改
    customerScening: {
        'url': url + 'auth/customerScening',
        'description': '用户情景场景保存/修改'
    },

    //用户情景场开启和关闭
    sceneOpenUpdate: {
        'url': url + 'auth/sceneOpenUpdate',
        'description': '用户情景场开启和关闭'
    },

    //用户情景场详情
    sceneView: {
        'url': url + 'auth/sceneView',
        'description': '用户情景场详情'
    },

    //用户联动场景保存/修改（设备必须要有1个传感器）
    customerLinking: {
        'url': url + 'auth/customerLinking',
        'description': '用户联动场景保存/修改（设备必须要有1个传感器）'
    },

    //晶控发送指令
    sendCommand: {
        'url': url + 'auth/sendCommand',
        'description': '晶控发送指令'
    },

    //用户设备分类修改
    customerDeviceCatUpdate: {
        'url': url + 'auth/customerDeviceCatUpdate',
        'description': '用户设备分类修改'
    },

    //用户设备名称修改
    customerDeviceNameUpdate: {
        'url': url + 'auth/customerDeviceNameUpdate',
        'description': '用户设备名称修改'
    },

    //用户凯图主机配置保存
    hostSave: {
        'url': url + "auth/hostSave",
        'description': '用户凯图主机配置保存'
    },
    getMyDomain: {
        'url': url + "auth/getMyDomain",
        'description': '获取凯图主机配置'
    },
    //根据设备id获取详情
    getDeviceDetail: {
        'url': url + 'auth/getDeviceDetail',
        'description': '根据设备id获取详情',
    },
    //凯图调色灯颜色保存
    kttsColorSave: {
        'url': url + "auth/kttsColorSave",
        'description': '凯图调色灯颜色保存'
    },
    getKttsColor: {
        'url': url + "auth/getKttsColor",
        'description': '获取凯图调色灯颜色'
    },
    //根据场景类型获取 模板配置
    listSceneMould: {
        'url': url + "auth/listSceneMould",
        'description': '根据场景类型获取 模板配置'
    },
    //获取有效的用户场景
    listScene: {
        'url': url + 'auth/listScene',
        'description': '获取场景'
    },
    //情景场详情
    sceneDetail: {
        'url': url + 'auth/sceneDetail',
        'description': '情景场详情'
    },
    //保存景场
    sceneSave: {
        'url': url + 'auth/sceneSave',
        'description': '保存景场'
    },
    //场景删除
    sceneDelete: {
        'url': url + 'auth/sceneDelete',
        'description': '场景删除'
    },
    //场景开启和关闭
    sceneOpenOrClose: {
        'url': url + 'auth/sceneOpenOrClose',
        'description': '场景开启和关闭'
    },
    //获取用户区域
    listArea: {
        'url': url + 'auth/listArea',
        'description': '获取用户区域'
    },
    //新增或修改用户区域
    saveArea: {
        'url': url + 'auth/saveArea',
        'description': '新增或修改用户区域'
    },
    //删除当前区域
    delArea: {
        'url': url + 'auth/delArea',
        'description': '删除当前区域'
    },
    //一键开启或关闭
    onKeyOnOff: {
        'url': url + 'auth/onKeyOnOff',
        'description': '一键开启或关闭'
    },
    //精讯查询单个传感器数据
    selSingleSensorData: {
        'url': url + 'auth/selSingleSensorData',
        'description': '查询单个传感器数据'
    },
    //精讯获取设备信息
    getDeviceInfo: {
        'url': url + 'auth/getDeviceInfo',
        'description': '获取设备信息'
    },
    //精讯继电器开关单路
    onOffRelay: {
        'url': url + 'auth/onOffRelay',
        'description': '继电器开关单路'
    },
    //精讯传感器历史记录
    selHistoryForDate: {
        'url': url + 'auth/selHistoryForDate',
        'description': '传感器历史记录'
    },
    //列出需要养护的
    maintainNotice: {
        'url': url + 'auth/maintainNotice',
        'description': '列出需要养护的'
    },
    //列出养护模板
    listMaintainMould: {
        'url': url + 'auth/listMaintainMould',
        'description': '列出养护模板'
    },
    //用户的养护记录库
    listMaintain: {
        'url': url + 'auth/listMaintain',
        'description': '用户的养护记录库'
    },
    //增加用户的养护记录库
    addMaintain: {
        'url': url + 'auth/addMaintain',
        'description': '增加用户的养护记录库'
    },
    //删除用户的养护记录库
    delMaintain: {
        'url': url + 'auth/delMaintain',
        'description': '删除用户的养护记录库'
    },
    //增加用户具体的养护记录
    addRecord: {
        'url': url + 'auth/addRecord',
        'description': '增加用户具体的养护记录'
    },
    //列出用户具体记录库下的数据
    listRecord: {
        'url': url + 'auth/listRecord',
        'description': '列出用户具体记录库下的数据'
    },
    //列出所有图标
    listIcon: {
        'url': url + 'no/listIcon',
        'description': '列出所有图标'
    },
    //用户手册
    listGuide: {
        'url': url + 'no/listGuide',
        'description': '用户手册'
    },
    //用户手册详情
    detailGuide: {
        'url': url + 'no/detailGuide',
        'description': '用户手册详情'
    },
    //调用后台控制设备
    operateDevice: {
        'url': url + 'auth/operateDevice',
        'description': '调用后台控制设备'
    },
    refreshInfo: {
        'url': url + 'auth/refreshInfo',
        'description': '刷新设备状态'
    },
    getInfoCache: {
        'url': url + 'auth/getInfoCache',
        'description': '获取设备的缓存状态'
    },
    //获取芯蚁设备的状态
    getInfo: {
        'url': url + 'auth/getInfo',
        'description': '获取芯蚁设备的状态'
    },
    getMusicInfo: {
        'url': url + 'auth/getMusicInfo',
        'description': '获取播放音乐状态'
    },
    listSD: {
        'url': url + 'auth/listSD',
        'description': '芯蚁主板sd卡目录'
    },
    playMusic: {
        'url': url + 'auth/playMusic',
        'description': '播放音乐'
    },
    setVolume: {
        'url': url + 'auth/setVolume',
        'description': '设置主板音量'
    },
    listSensorRecord: {
        'url': url + 'auth/listSensorRecord',
        'description': '获取传感器的历史记录'
    },
    listAreaMapDevice: {
        'url': url + 'auth/listAreaMapDevice',
        'description': '列出该地图下所有设备'
    },
    saveMapDevice: {
        'url': url + 'auth/saveMapDevice',
        'description': '新增/更新地图设备/拖拽添加'
    },
    delAreaMapDevice: {
        'url': url + 'auth/delAreaMapDevice',
        'description': '删除该地图下的设备'
    },
    sortMap: {
        'url': url + 'auth/sortMap',
        'description': '修改地图排序'
    },
    addAreaMap: {
        'url': url + 'auth/addAreaMap',
        'description': '增加该区域下的图'
    },
    listAreaMap: {
        'url': url + 'auth/listAreaMap',
        'description': '列出该区域下所有地图'
    },

    listSensorStandard: {
        'url': url + 'no/listSensorStandard',
        'description': '数据评价标准'
    },
    delMap: {
        'url': url + 'auth/delMap',
        'description': '删除该区域下的图及设备对应'
    },
    listAppContent: {
        'url': url + 'auth/listAppContent',
        'description': '列出区域下竖屏内容'
    },
    saveAppItem: {
        'url': url + 'auth/saveAppItem',
        'description': '增加/修改区域下竖屏内容'
    },
    delItem: {
        'url': url + 'auth/delItem',
        'description': '删除区域下竖屏内容'
    },
};

export default api;
